import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_69: DocMigration = {
  maxSchemaVersion: "0.0.69",
  description: "RoomLayout.baseLayoutId should be null when undefined",
  apply(json: any) {
    if (!json.roomLayouts) {
      return json;
    }

    for (const roomId in json.roomLayouts) {
      if (typeof json.roomLayouts[roomId].baseLayoutId === "undefined") {
        json.roomLayouts[roomId].baseLayoutId = null;
      }
    }

    return json;
  },
};

export default migration_0_0_69;
